import React, { useState } from 'react';
import { Card, Form, Button, Alert } from 'react-bootstrap';
import { changePassword } from '../../api/userApi';
import { MdLock, MdSecurity, MdVpnKey } from 'react-icons/md';
import '../../StylesCSS/ChangePassword.css';

const ChangePassword = () => {

    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');

    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();

        setError('');
        setSuccess('');

        if (newPassword.length < 6) {
            setError('يجب أن تتكون كلمة المرور الجديدة من 6 أحرف على الأقل.');
            return;
        }

        if (newPassword !== confirmPassword) {
            setError('كلمة المرور الجديدة وتأكيدها غير متطابقين.');
            return;
        }

        try {

            const userId = localStorage.getItem('userId');

            await changePassword({
                userId: Number(userId),
                currentPassword,
                newPassword
            });

            setSuccess('تم تغيير كلمة المرور بنجاح.');

            setCurrentPassword('');
            setNewPassword('');
            setConfirmPassword('');

        } catch (err) {

            if (err.response?.data?.message) {
                setError(err.response.data.message);
            } else {
                setError('حدث خطأ أثناء تغيير كلمة المرور.');
            }
        }
    };

    const passwordMismatch =
        confirmPassword.length > 0 &&
        newPassword !== confirmPassword;

    return (
        <section className="change-password-page" dir="rtl">
            <div className="change-password-shell">
                <header className="change-password-hero">
                    <span className="change-password-kicker">أمان الحساب</span>
                    <h1>تغيير كلمة المرور</h1>
                    <p>احموا حسابكم باستخدام كلمة مرور شخصية يصعب تخمينها.</p>
                </header>

                <Card className="change-password-card border-0">
                    <Card.Body className="p-0">
                        <h2 className="change-password-card-title">
                            <MdLock aria-hidden="true" />
                            تعديل بيانات الدخول
                        </h2>

                        {error && (
                            <Alert variant="danger" className="change-password-alert">
                                {error}
                            </Alert>
                        )}

                        {success && (
                            <Alert variant="success" className="change-password-alert">
                                {success}
                            </Alert>
                        )}

                        <Form onSubmit={handleSubmit} className="change-password-form">

                            <Form.Group className="change-password-field">
                                <Form.Label>كلمة المرور الحالية</Form.Label>

                                <Form.Control
                                    type="password"
                                    value={currentPassword}
                                    onChange={(e) => setCurrentPassword(e.target.value)}
                                    placeholder="أدخل كلمة المرور الحالية"
                                    required
                                />
                            </Form.Group>

                            <Form.Group className="change-password-field">
                                <Form.Label>كلمة المرور الجديدة</Form.Label>

                                <Form.Control
                                    type="password"
                                    value={newPassword}
                                    onChange={(e) => setNewPassword(e.target.value)}
                                    placeholder="6 أحرف على الأقل"
                                    required
                                />
                            </Form.Group>

                            <Form.Group className="change-password-field">
                                <Form.Label>تأكيد كلمة المرور الجديدة</Form.Label>

                                <Form.Control
                                    type="password"
                                    value={confirmPassword}
                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                    placeholder="أعد إدخال كلمة المرور الجديدة"
                                    required
                                    isInvalid={passwordMismatch}
                                />

                                <Form.Control.Feedback type="invalid">
                                    كلمتا المرور غير متطابقتين.
                                </Form.Control.Feedback>
                            </Form.Group>

                            <div className="change-password-hint">
                                <MdSecurity aria-hidden="true" />
                                يجب أن تحتوي كلمة المرور الجديدة على 6 أحرف على الأقل.
                            </div>

                            <div className="change-password-actions">
                                <Button type="submit" className="change-password-submit">
                                    <MdVpnKey aria-hidden="true" />
                                    حفظ كلمة المرور الجديدة
                                </Button>
                            </div>
                        </Form>
                    </Card.Body>
                </Card>
            </div>
        </section>
    );
};

export default ChangePassword;